import { DefaultSeo } from '@jaredrolt/next-seo';
import Head from 'next/head';
import { buildHeImgixUrl } from '../../common/components/images/imgix';

const SHARE_IMAGE = buildHeImgixUrl('public/images/og_image_20210913083905.jpeg');

const JSON_LD_BLOCK = JSON.stringify({
  '@context': 'http://schema.org',
  '@type': 'WebSite',
  name: 'Healthengine',
  url: 'https://healthengine.com.au',
});

interface Props {
  absoluteUrl: string;
}

export const GlobalSeo = ({ absoluteUrl }: Props) => (
  <>
    <DefaultSeo
      openGraph={{
        title: 'Healthengine',
        type: 'website',
        images: [
          {
            url: SHARE_IMAGE,
            width: 145,
            height: 145,
            alt: 'Healthengine',
          },
        ],
        // This library requires non-camelcase
        // eslint-disable-next-line camelcase
        site_name: 'Healthengine',
        description:
          'Find and book health appointments online, 24/7. View all available appointments in your local area and choose a time and place that suits you.',
      }}
      facebook={{ appId: '123303097714935' }}
      twitter={{
        cardType: 'app',
        site: '@healthengine',
      }}
      doNotRenderDefaultRobotsTags={true}
    />

    <Head>
      <link rel="canonical" href={absoluteUrl} />

      <script
        type="application/ld+json"
        // This won't be parsed properly if the quotes get escaped, so we have to set it as innerHTML
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON_LD_BLOCK }}
      ></script>
      <meta name="twitter:app:name:iphone" content="Healthengine" />
      <meta name="twitter:app:id:iphone" content="498446578" />
      <meta name="twitter:app:name:ipad" content="Healthengine" />
      <meta name="twitter:app:id:ipad" content="498446578" />
      <meta name="twitter:app:name:googleplay" content="Healthengine" />
      <meta name="twitter:app:id:googleplay" content="com.healthengine.android" />
      <meta property="fb:admins" content="1187258939" />
      <meta
        name="twitter:description"
        content="Find & book health appointments, 24/7 with Healthengine, Australia’s #1 healthcare app. Download now to book an appointment anytime, anywhere."
      />
      <meta property="og:url" content={absoluteUrl} />
      <meta property="og:image:secure_url" content={SHARE_IMAGE} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="format-detection" content="telephone=no" />
      <meta itemProp="url" content={absoluteUrl} />
      <meta name="google-site-verification" content="MhtRL9VHxDjFk6vWNYPPj7bsXo3pqZNwldg2ZgJTeMY" />
    </Head>
  </>
);
